import React from 'react';
import "../../../StyleSheet/AppComponent/InputFields/InputFields.scss";

const Email = (props) => {
    const { value, onChange, Error  , label , type} = props;
    return (
        <>
            <div className='Outer-Inputs'>
                <label>{label}  </label>
                
                <div className='Email inputFields'>
                    <input type={type} value={value} name="email" onChange={onChange} autoComplete='on' />
                </div>
                <p style={{ color: "red",  }} className='Errors_list'>{Error}</p>
            </div>

        </>
    )
}

export default Email
